import { Language } from '@cigarsnap/shared/types';

export const defaultLocale: Language = 'en';
export const locales: Language[] = ['en', 'es', 'ar', 'ru', 'zh'];
export const cookieName = 'NEXT_LOCALE';
